function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import {useTranslation} from "../../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import React, {useMemo} from "react";
import Icon from "../../../atoms/icon/icon.component.js";
import {TableCellContainer} from "./table-cell.styles.js";
function TableCell({
  $fixWidth,
  $selected,
  $hidden,
  $initial,
  $pointer,
  $hover,
  $bxShadow,
  $fixLeft,
  $fixRight,
  align,
  children,
  dataCy,
  translate,
  ...rest
}) {
  const {
    t
  } = useTranslation();
  const _dataCy = useMemo(() => dataCy || translate || children, [children, dataCy, translate]);
  const textContent = useMemo(() => {
    if (children) {
      return children;
    }
    return translate ? t(translate) : "";
  }, [children, t, translate]);
  const isBoolean = typeof children === "boolean";
  return /* @__PURE__ */ React.createElement(TableCellContainer, _extends({
    $fixWidth,
    $hidden,
    $initial,
    $pointer,
    $fixLeft,
    $fixRight,
    align: isBoolean ? "center" : align,
    $selected,
    $hover,
    $bxShadow,
    "data-cy": _dataCy
  }, rest), isBoolean ? /* @__PURE__ */ React.createElement(Icon, {
    color: "secondary",
    size: "medium"
  }, children ? "check" : "") : textContent);
}
export default /* @__PURE__ */ React.memo(TableCell);
